import styled from "styled-components";

export const Container = styled.div`
  width: ${(props) => props.width || "342px"};
  height: ${(props) => props.height || "48px"};
  border-radius: 2px;
  display: flex;
  align-items: center;
  @media (max-width:1440px) {
    width: ${(props) => props.width1440 || "282px"};
  }
  @media (max-width: 1312px) {
    width: ${(props) => props.width1312 || "262px"};
  }
  @media (max-width: 1150px) {
    width: ${(props) => props.width1150 || "232px"};
  }
  @media (max-width: 1024px) {
    width: ${(props) => props.width600 || "264px"};
  }
  @media (max-width: 580px) {
    width: ${(props) => props.width600 || "328px"};
    height: 42px;
  }
`;

export const Element = styled.input`
  direction: ltr;
  background: ${(props) => props.background};
  outline: none;
  border: none;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 8px 16px;
  ::placeholder {
    color: ${(props) => props.placeholderColor};
    opacity: 1;
  }
  font-family: Peyda;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: ${(props) => props.fontColor};
`;



export const Wrapper = styled.div`
  min-height: ${props => props.minHeight};
   direction: rtl;
`